<template>
  <div>
    <form class="row" v-if="!sent">
      <div class="col-12">
        <div class="row">
          <div class="col-md-6">
            <div class="form-label-group">
              <input
                type="text"
                id="name"
                class="form-control form-control-flush"
                v-model="form.name"
                name="name"
                placeholder="Your Full Name"
                required
                @invalid="invalidateForm"
                :class="[$v.form.name.$invalid ? 'is-invalid' : 'is-valid']"
              />
              <label for="name">Your Name</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-label-group">
              <input
                type="email"
                class="form-control form-control-flush"
                v-model="form.email"
                name="email"
                placeholder="Your Email"
                required
                @invalid="invalidateForm"
                :class="[$v.form.email.$invalid ? 'is-invalid' : 'is-valid']"
              />
              <label for="name">Your Email</label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-label-group">
          <input
            type="text"
            class="form-control form-control-flush"
            id="subject"
            v-model="form.subject"
            name="subject"
            placeholder="Subject"
            required
            @invalid="invalidateForm"
          />
          <label for="subject">Subject</label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-label-group">
          <textarea
            id="message"
            class="form-control form-control-flush"
            v-model="form.message"
            name="message"
            placeholder="Your Message"
            rows="4"
            required
            @invalid="invalidateForm"
          ></textarea>
          <label for="message">Your Message</label>
        </div>
        <div class="text-center mb-5">
          <button
            type="submit"
            @click.prevent="sendForm"
            :disabled="sending || $v.$invalid"
            v-bind:class="[$v.$invalid ? 'btn btn-primary' : 'btn btn-success']"
          >
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </form>
    <template v-else
      ><h3 class="text-center">
        Thank you! We will be in touch soon.
      </h3></template
    >
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      sent: false,
      sending: false,
      form: {
        name: "",
        email: "",
        subject: "",
        message: "",
      },
    };
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
    },
  },
  mounted() {
    self.sent = false;
  },
  computed: {
    btnLabel() {
      return this.sending ? "Sumbitting..." : "Send Form";
    },
  },
  methods: {
    invalidateForm() {
      this.errors = true;
    },
    async sendForm() {
      let self = this;
      self.sending = true;
      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha("contact_form");
      if (!this.errors) {
        this.axios
          .post(window.API_URL + "contact", this.form)
          .then(function (response) {
            if (response.data.status == "success") {
              self.sent = true;
              self.sending = false;
            }
          });
      }
    },
  },
};
</script>